@if (actionPlanId && actionPlanCommentConfigTypeId) {
  <svc-comments-chat
    [svcTestId]="'ap-form-feed__section--comments-chat-id-' + actionPlanId"
    class="block overflow-x-hidden min-h-[400px] mt-10"
    [placeholder]="'Comentar' | transloco"
    [referenceId]="actionPlanId"
    [configTypeId]="actionPlanCommentConfigTypeId"
    [applicationId]="actionPlanApplicationId"
    (commentsTotalChange)="onCommentsTotalChange($event)"
    (onCommentAdded)="onCommentsChanged()"
    (onCommentRemoved)="onCommentsChanged()"
  ></svc-comments-chat>
}
